import createBooking from './createBooking'
import updateBooking from './updateBooking'

export default [createBooking, updateBooking]
